import type { Component } from 'react';

import { withAlignment } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import BpkLargeCarsIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/cars';
import BpkLargeChevronRightIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/chevron-right';
import BpkLargeFlightsIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/flight';
import BpkLargeFlightsToIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/flight-landing';
import BpkLargeFlightsFromIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/flight-takeoff';
import BpkLargeHotelsIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/hotels';
import BpkLargeInformationCircleIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/information-circle';
import BpkLargeTripsIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/trips';

import {
  lineHeightXl,
  iconSizeLg,
} from '@skyscanner/bpk-foundations-web/tokens/base.es6';

import { useMBDContext } from '../../common/MBD/useMBDContext';

import type { CrossLinkItem } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './CrossLink.module.scss';

type CategoryIconMap = {
  [key: string]: Component;
};

const iconsForCategory: CategoryIconMap = {
  'car-hire': BpkLargeCarsIcon,
  flightsTo: BpkLargeFlightsToIcon,
  flightsFrom: BpkLargeFlightsFromIcon,
  hotels: BpkLargeHotelsIcon,
  flights: BpkLargeFlightsIcon,
  flightsArrivalsDepartures: BpkLargeFlightsIcon,
  destinations: BpkLargeTripsIcon,
};

const alignedIconForCategory = (category: string) =>
  withAlignment(
    iconsForCategory[category]
      ? iconsForCategory[category]
      : BpkLargeInformationCircleIcon,
    lineHeightXl,
    iconSizeLg,
  );

const AlignedChevronRightIcon = withAlignment(
  BpkLargeChevronRightIcon,
  lineHeightXl,
  iconSizeLg,
);

const CrossLink = ({ category, index, label, url }: CrossLinkItem) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const mbdComponentName = `${rawComponentName}_item`;

  const IconForCategory = alignedIconForCategory(category);
  return (
    <li className={STYLES.CrossLink}>
      <a
        className={STYLES.linkListItem}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        data-tracking-element-id={`${mbdComponentName}_${index}`}
        data-tracking-common-params={buildMBDParam(mbdComponentName, {
          category,
        })}
      >
        <IconForCategory className={STYLES.CrossLink__icon} />
        <span className={STYLES.CrossLink__text}>{label}</span>
        <AlignedChevronRightIcon className={STYLES.CrossLink__chevron} />
      </a>
    </li>
  );
};

export default CrossLink;
